import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Tab, Tabs } from '../../components/Tabs/Tabs';
import { transactionActions } from '../../redux/actions/transactionActions';
import MainTab from './MainTab';

const TransactionPage = () => {
  const dispatch = useDispatch();
  const { activeTabKey } = useSelector(state => state.transaction);

  return (
    <div>
      <Tabs
        activeKey={activeTabKey}
        onClick={key => dispatch(transactionActions.changeTab(key))}
      >
        <Tab title="Transaksi">
          <MainTab />
        </Tab>
      </Tabs>
    </div>
  )
}

export default TransactionPage
